import {GrDeliver} from 'react-icons/gr';

const CartResume = (props)=>{
    return <div className="cartResumeContainer">
        { props.isfreeshipping &&
            <div className="cartResumeShippingfree">
                <span>Tú envío va por nuestra cuenta</span>
                <GrDeliver/>
            </div>
        }
        <ul className="cartResume">
            <li className="cartResumeTitle">Resumen del pedido</li>
            <li>
                <span>Productos</span>
                <b>${props.subtotal}</b>
            </li>
            {
                props.coupon > 0 && <li><span>Descuento</span><b>-${props.coupon}</b></li>
            }
            {(props.vip) ? (
                <li>
                    <span>Envío VIP (<small>{props.municipio}</small>)</span><b>${props.shipping}</b>
                </li>
            ) : (
                <li>
                    <span>Envío (<small>{props.municipio}</small>)</span>
                    {(props.isfreeshipping) ? (
                        <b><small>${props.shipping}</small>$0</b>
                    ) : (
                        <b>${props.shipping}</b>
                    )}
                </li>
            )}
            {
                props.msi > 0 && <li><span>Comisión pago diferido</span><b>${props.msi}</b></li>
            }
            <li>
                <span>Total</span>
                <b>${props.total}</b>
            </li>
        </ul>
    </div>
};

export default CartResume;